import Grain from './components/Grain';
import Masthead from './components/Masthead';
import Hero from './components/Hero';
import About from './components/About';
import Toolbox from './components/Toolbox';
import Work from './components/Work';
import Correspondence from './components/Correspondence';
import Colophon from './components/Colophon';
import useReveal from './hooks/useReveal';

import './Home.css';


function Home() {
  useReveal();

  return (
    <div className='page'>
      <Grain/>
      <Masthead/>
      <main>
        <Hero/>
        <About/>
        <Toolbox/>
        <Work/>
        <Correspondence/>
      </main>
      <Colophon/>
    </div>
  );
}

export default Home;
